import { useSearchParams } from "react-router-dom";
import { FeatureFlagGuard } from "@/components/FeatureFlagGuard";

interface ActivityRouteGuardProps {
  children: React.ReactNode;
}

export function ActivityRouteGuard({ children }: ActivityRouteGuardProps) {
  const [searchParams] = useSearchParams();
  const pathId = searchParams.get("pathId");

  // If pathId is present, this is a path-context activity → bypass feature flag
  if (pathId) return <>{children}</>;

  // Otherwise, apply the standalone activities feature flag
  return (
    <FeatureFlagGuard flagKey="feature_standalone_activities_enabled">
      {children}
    </FeatureFlagGuard>
  );
}

